import { Link } from "react-router-dom";
import type { Food } from "@/mocks/foods";
import StarRating from "./StarRating";

interface FoodCardProps {
  food: Food;
  className?: string;
}

export default function FoodCard({ food, className = "" }: FoodCardProps) {
  return (
    <Link
      to={`/food-detail/${food.id}`}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition duration-300 hover:-translate-y-1 hover:border-primary-300 ${className}`}
    >
      <div className="relative h-48 w-full overflow-hidden bg-background-100">
        <img
          src={food.image}
          alt={`${food.name} - 美味的快递美食外卖`}
          title={`${food.name} - 美味的快递美食外卖`}
          className="h-full w-full object-top transition duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-bold text-primary-700 backdrop-blur">
          {food.category}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-background-50">
          <i className="ri-fire-fill" />
          {food.sales > 2000 ? "爆款" : "热卖"}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 transition group-hover:text-primary-600">
          {food.name}
        </h3>
        <p className="mt-1.5 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">{food.short}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {food.tags.slice(0, 3).map((t) => (
            <span key={t} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {t}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3">
          <StarRating rating={food.rating} />
          <span className="flex items-baseline gap-0.5">
            <span className="text-xs text-foreground-500">¥</span>
            <span className="font-heading text-xl font-extrabold text-primary-600">{food.price}</span>
          </span>
        </div>
      </div>
    </Link>
  );
}